import { render, staticRenderFns } from "./MsgComponent.vue?vue&type=template&id=4e338572&scoped=true&"
import script from "./MsgComponent.vue?vue&type=script&lang=js&"
export * from "./MsgComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e338572",
  null
  
)

export default component.exports